import { render, staticRenderFns } from "./listarInspeccionElementosBotiquin.vue?vue&type=template&id=05215382"
import script from "./listarInspeccionElementosBotiquin.vue?vue&type=script&lang=js"
export * from "./listarInspeccionElementosBotiquin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports